import React, { useEffect, useState } from "react";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import { runInAction, toJS } from "mobx";
import { observer } from "mobx-react-lite";
import EventLabel from "../../components/EventLabel";
export const GroupRegistration = observer((props) => {
  const { validations, settings, triggerValidation, checkConditions, createOrder, current, environment, orders, checkEventAvailability,getFilteredValidations } = props;
  const [showEventFull, setShowEventFull] = useState(false);
  let isValid = getFilteredValidations() == 0;
  const { hidden, maxCount = 0 } = settings;
  useEffect(() => {
    (async () => {
      setShowEventFull(!await checkEventAvailability(environment.eventId));
    })()
  }, [])
  if (hidden) return null;
  return (
    <>
      <button
        className="cms-button"
        disabled={(maxCount > 0 && orders.length >= maxCount) || showEventFull}
        onClick={async () => {
          if (isValid) {
            let isAvailable = await checkEventAvailability(environment.eventId)
            if (isAvailable) {
              runInAction(() => {
                triggerValidation(false);
                let shouldFocus = false;
                if (current.activePage == settings.returnPage) shouldFocus = true;
                current.activePage = settings.returnPage;
                createOrder();
                checkConditions();
                if (shouldFocus)
                  document.querySelector(".react-grid-layout input:not(readonly):not(disabled), .react-grid-layout textarea:not(readonly):not(disabled), .react-grid-layout select:not(readonly):not(disabled)")?.focus();
              });
            }
            else {
              setShowEventFull(!isAvailable);
            }
          } else {
            triggerValidation();
          }
        }}
      >
        <PersonAddIcon />
        {
          maxCount > 0 && orders.length >= maxCount ?
            <EventLabel name={"MaxGroupCountReached"} groupName={"Cms.GroupModule"} />
            :
            (showEventFull ?
              <EventLabel name={"MainEventFull"} groupName={"Cms.GroupModule"} />
              :
              <EventLabel name={"AddNewOrderBtn"} groupName={"Cms.GroupModule"} />)
        }
      </button>
    </>
  );
});
